import { render } from "./ProcessorDashboard.vue?vue&type=template&id=3bfe9154&scoped=true"
import script from "./ProcessorDashboard.vue?vue&type=script&lang=js"
export * from "./ProcessorDashboard.vue?vue&type=script&lang=js"

import "@/assets/css/commandcenter/commandcenter.css?vue&type=style&index=0&lang=css&external"
import "./ProcessorDashboard.vue?vue&type=style&index=1&id=3bfe9154&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bfe9154"]])

export default __exports__